import { VisibilityState } from '@tanstack/react-table';
import { atom } from 'jotai';

import { defaultTabularTableColumnVisibilityState } from 'components/inspections/AnomalyData/tabularTableColumns';

export const tabularTableCSVDataAtom = atom<Record<string, string>[]>([]);

export const tabularTableColumnVisibilityAtom = atom<VisibilityState>(defaultTabularTableColumnVisibilityState);
